
import { Controller } from "stimulus";

export default class extends Controller {

  static targets = ["sourceField", "destinationField", "sourceType"]
  connect(){
    console.log("date converter reporting for duty")
  }
  convertToGD(_event, element) {
    var date_val = _event.target.value
    var dest = document.getElementById(_event.target.getAttribute("data-destination-field"))
    var date = (new Date(date_val))

    var jd = $.calendars.instance('ummalqura').newDate(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate()).toJD();
    dest.value = $.calendars.instance('gregorian').fromJD(jd)


  }

  convertToHijri(_event, element) {
    var date_val = _event.target.value
    var dest = document.getElementById( _event.target.getAttribute("data-destination-field"))
    var date = (new Date(date_val))
    var jd = $.calendars.instance('gregorian').newDate(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate()).toJD();
    dest.value = $.calendars.instance('ummalqura').fromJD(jd)

  }

}